import React from "react";

export default function SettingsSection({
                                            title,
                                            subtitle,
                                            children,
                                            fullWidth,
                                            noBorder,

                                        }: {
    children: React.ReactNode,
    title?: string
    subtitle?: string | React.ReactNode;
    noBorder?: boolean;
    fullWidth?: boolean;
}) {
    return <div className={`relative grid grid-cols-1 md:grid-cols-2 gap-4 ${noBorder ? '' : 'border-b border-base-200 pb-4 py-3'}`}>
        <div>
            <div className={"mb-2"}>
                <h4 className={"text-xl mb-2"}>{title}</h4><div className={"opacity-75"}>{subtitle}</div>
            </div>
        </div>
        <div className={fullWidth ? 'col-12' : "col-md-6"}>
            {children}
        </div>
    </div>
}
